export enum PriceEditModalActions {
  OpenPriceEditModal = 'OpenPriceEditModal New Grid',
  ClosePriceEditModal = 'ClosePriceEditModal New Grid',
  AddPeriod = 'AddPeriod New Grid',
  RemovePeriod = 'RemovePeriod New Grid',
  SetPeriod = 'SetPeriod New Grid',
  SelectRoom = 'SelectRoom New Grid',
  SetRooms = 'SetRooms New Grid',
  SetPrice = 'SetPrice New Grid',
  SetRestrictions = 'SetRestrictions New Grid',
  SetData = 'SetData New Grid',
  Save = 'Save New Grid',
  SetLoader = 'SetLoader New Grid',
  RegisterField = 'RegisterField New Grid',
  SetErrors = 'SetErrors New Grid',
  SetKeepRestrictions = 'SetKeepRestrictions New Grid',
}
